export default "__VITE_ASSET__DXJfAB4F__"